import * as React from "react";

function SvgCollapseIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="1em" height="1em" viewBox="0 0 43 43" {...props}><circle cx={21.5} cy={21.5} fill="#F5F6FB" r={21.5} /><path d="M19.764 16.523c.767-1.343 2.705-1.343 3.472 0l4.554 5.97c.762 1.332-.2 2.991-1.736 2.991h-9.108c-1.535 0-2.498-1.659-1.736-2.992l4.554-5.969z" fill="currentColor" /></svg>;
}

export default SvgCollapseIcon;